import Button from "@mui/material/Button";

const ContainedButton = ({ label, ...props }) => {

    return (
        <Button
            sx={{
                height: "40px",
                textTransform: "none"
            }}
            variant="contained"
            {...props}
        >
            {label}
        </Button>
    );
};

export default ContainedButton;